type FlowDiamondProps = {
  name: string;
  width?: number;
  height?: number;
  fontSize?: number;
};

const FlowDiamond = ({
  name,
  width = 90,
  height = 33,
  fontSize,
}: FlowDiamondProps) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const calculatedFontSize = fontSize ?? Math.min(width, height) * 0.5;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <polygon
        points={`
          ${centerX},1 
          ${width - 1},${centerY} 
          ${centerX},${height - 1} 
          1,${centerY}
        `}
        fill="#FFFFFF"
        stroke="#1E3A8A"
        strokeWidth="1"
      />

      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={calculatedFontSize}
        fontWeight={600}
        fill="#1E3A83"
        pointerEvents="none"
      >
        {name}
      </text>
    </svg>
  );
};

export default FlowDiamond;
